import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import QuestionsBeforeYouDiveIn from '../../components/QuestionsBeforeYouDiveIn';
import { Grid } from '@material-ui/core';
import QuestionsSomewhereAlongTheWay from '../../components/QuestionsSomewhereAlongTheWay';
import QuestionsMoney from '../../components/QuestionsMoney';
import CTA from "../../components/CTA";

import './style.scss';


const FaqPage = () => {
    return(
        <Fragment>
            <Helmet>
                <title>Faq</title>
                <meta name="description" content="Todos!" />
            </Helmet>
            <BreadCrumb
                pagename=" Faq "
                title="There are only some dumb questions. Just kidding."
            />          
            <Grid className='faqtext'>
                <h4>If you have questions during the process, we’ve got you covered. Take a glance at the Frequently Asked Questions below and we’re willing to bet that you’ll find your answer.  </h4>
            </Grid>
            <QuestionsBeforeYouDiveIn/>
            <QuestionsSomewhereAlongTheWay/>
            <QuestionsMoney />
            <Grid className='faqtext'>
                <h4>Still got questions? We’re here for you. Chat with us in the bottom right corner of the website or contact us today. </h4>
                <br/>
                
            </Grid>
            <CTA/> 
           
            <Footer/>
        </Fragment>
    )
};

export default FaqPage;